import React from 'react';
import { Helmet } from "react-helmet-async";
import { BASE_URL } from '../config/config';

const Seo = ({
  title = 'Testmeter - Your Gateway to Success',
  description = 'Quality courses, expert faculty, and comprehensive study materials for competitive exams like UPSC, SSC, Banking and more.',
  keywords = 'competitive exams, online courses, UPSC, SSC, banking exams, test series, study materials',
  image = `default-og-image.jpg`,
  url = typeof window !== 'undefined' ? window.location.href : '',
  type = 'website',
  author = 'Brainershub',
  publishedTime,
  modifiedTime,
  category,
  tags = []
}) => {
  
  // Generate JSON-LD structured data
  const structuredData = {
    "@context": "https://schema.org",
    "@type": type === 'article' ? "Article" : "WebPage",
    "headline": title,
    "description": description,
    "image": image,
    "url": url,
    "author": {
      "@type": "Organization",
      "name": author,
      "url": BASE_URL
    },
    "publisher": {
      "@type": "Organization",
      "name": "Brainershub",
      "logo": {
        "@type": "ImageObject",
        "url": `logo.png`
      }
    },
    ...(publishedTime && { "datePublished": publishedTime }),
    ...(modifiedTime && { "dateModified": modifiedTime }),
    ...(category && { "articleSection": category }),
    ...(tags.length > 0 && { "keywords": tags.join(', ') })
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      
      {/* Open Graph Tags (Facebook, LinkedIn) */}
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="Brainershub" />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title} />
      
      {type === 'article' && (
        <>
          <meta property="article:published_time" content={publishedTime} />
          <meta property="article:modified_time" content={modifiedTime} />
          <meta property="article:author" content={author} />
          {category && <meta property="article:section" content={category} />}
          {tags.map((tag, index) => (
            <meta key={index} property="article:tag" content={tag} />
          ))}
        </>
      )}
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@brainershub" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:creator" content="@brainershub" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default Seo;